/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_Core_Dtos_PagedResultDto_1 } from '../models/Routemize_Core_Dtos_PagedResultDto_1';
import type { Routemize_DTOs_CompanyLocationDto } from '../models/Routemize_DTOs_CompanyLocationDto';
import type { Routemize_DTOs_CompanyLocationDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_ } from '../models/Routemize_DTOs_CompanyLocationDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_';
import type { Routemize_DTOs_CreateUpdateCompanyLocationDto } from '../models/Routemize_DTOs_CreateUpdateCompanyLocationDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CompanyLocationService {
    /**
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns Routemize_Core_Dtos_PagedResultDto_1<Routemize_DTOs_CompanyLocationDto_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_> OK
     * @throws ApiError
     */
    public static getApiAppCompanyLocationGetList(
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<Routemize_Core_Dtos_PagedResultDto_1> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/companyLocation/getList',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
        });
    }
    /**
     * @param id
     * @returns Routemize_DTOs_CompanyLocationDto OK
     * @throws ApiError
     */
    public static getApiAppCompanyLocationGet(
        id: string,
    ): CancelablePromise<Routemize_DTOs_CompanyLocationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/companyLocation/{id}/get',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_CompanyLocationDto OK
     * @throws ApiError
     */
    public static postApiAppCompanyLocationCreate(
        requestBody?: Routemize_DTOs_CreateUpdateCompanyLocationDto,
    ): CancelablePromise<Routemize_DTOs_CompanyLocationDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/companyLocation/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns Routemize_DTOs_CompanyLocationDto OK
     * @throws ApiError
     */
    public static putApiAppCompanyLocationUpdate(
        id: string,
        requestBody?: Routemize_DTOs_CreateUpdateCompanyLocationDto,
    ): CancelablePromise<Routemize_DTOs_CompanyLocationDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/companyLocation/{id}/update',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAppCompanyLocationDelete(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/companyLocation/{id}/delete',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns Routemize_DTOs_CompanyLocationDto OK
     * @throws ApiError
     */
    public static getApiAppCompanyLocationGetAllActive(): CancelablePromise<Array<Routemize_DTOs_CompanyLocationDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/companyLocation/getAllActive',
        });
    }
    /**
     * @param id
     * @returns Routemize_DTOs_CompanyLocationDto OK
     * @throws ApiError
     */
    public static postApiAppCompanyLocationSetDefault(
        id: string,
    ): CancelablePromise<Routemize_DTOs_CompanyLocationDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/companyLocation/{id}/setDefault',
            path: {
                'id': id,
            },
        });
    }
}
